import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { map } from 'rxjs/operators';

@Injectable()
export class EventService {
  eventsUrl: string = environment.config.eventsUrl;
  grievanceUrl: string = environment.config.grievanceUrl;
  constructor(private http: HttpClient) { }

  getCokkies(param) {
    // const name = param + '=';
    // const decodedCookie = decodeURIComponent(document.cookie);
    // console.log('decodedCookie', decodedCookie);
    // const ca = decodedCookie.split(';');
    // for (const i of ca) {
    //   let c = i;
    //   while (c.charAt(0) === ' ') {
    //     c = c.substring(1);
    //   }
    //   if (c.indexOf(name) === 0) {
    //     return c.substring(name.length, c.length);
    //   }
    // }
    // return '';
  }
  getAllCategories() {
    return this.http.get(this.eventsUrl + 'api/category').pipe(map(res => res));
  }

  signup(type, data) {
    const api = type === 'citizen' ? 'citizenSignup' : 'officialSignup';
    return this.http
      .post(this.eventsUrl + 'api/auth/' + api, data)
      .pipe(map(res => res));
  }

  signupInsti(data) {
    return this.http
      .post(this.eventsUrl + 'api/auth/institutionSignup', data)
      .pipe(map(res => res));
  }

  signin(data) {
    return this.http
      .post(this.grievanceUrl + 'api/v1/user/login', data)
      .pipe(map(res => res));
  }

  createEvent(data) {
    return this.http
      .post(this.eventsUrl + 'api/event', data)
      .pipe(map(res => res));
  }

  updateProfile(data) {
    return this.http
      .patch(this.eventsUrl + 'api/user/personalDetails', data)
      .pipe(map(res => res));
  }

  createSponsor(data) {
    return this.http
      .post(this.eventsUrl + 'api/sponsor', data)
      .pipe(map(res => res));
  }

  getOneEvent(id) {
    return this.http
      .get(this.eventsUrl + 'api/event/' + id)
      .pipe(map(res => res));
  }

  getAllEvent() {
    return this.http.get(this.eventsUrl + 'api/event').pipe(map(res => res));
  }

  uploadProfile(formData, api) {
    return this.http
      .post(this.eventsUrl + 'api/' + api, formData)
      .pipe(map(res => res));
  }

  updateDetailForEvent(eventId, data) {
    return this.http
      .patch(this.eventsUrl + 'api/event/' + eventId, data)
      .pipe(map(res => res));
  }

  updateDetailForSponsor(eventId, data) {
    return this.http
      .patch(this.eventsUrl + 'api/sponsor/' + eventId, data)
      .pipe(map(res => res));
  }

  loginWithSocial(data) {
    return this.http
      .post(this.eventsUrl + 'api/auth/citizenGoogleFbSignupLogin', data)
      .pipe(map(res => res));
  }

  getLikes(eventId) {
    return this.http
      .get(this.eventsUrl + 'api/event/checkLiked/' + eventId)
      .pipe(map(res => res));
  }

  addLikes(eventId) {
    return this.http
      .post(this.eventsUrl + 'api/event/likeEvent/' + eventId, {})
      .pipe(map(res => res));
  }

  addVolenteer(data, eventId) {
    return this.http
      .post(this.eventsUrl + 'api/event/addVolunteer/' + eventId, data)
      .pipe(map(res => res));
  }

  changePassword(data) {
    return this.http
      .post(this.eventsUrl + 'api/auth/changePassword', data)
      .pipe(map(res => res));
  }

  getStates() {
    return this.http
      .get(environment.config.apiUrl + 'master/state-list')
      .pipe(map(res => res));
  }
}
